import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Play, Info } from "lucide-react";
import { Movie } from "@/data/movies";

interface HeroProps {
  movie: Movie;
}

export function Hero({ movie }: HeroProps) {
  return (
    <div className="relative h-96 md:h-[500px] overflow-hidden rounded-lg mb-8">
      <img
        src={movie.backdrop}
        alt={movie.title}
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/40 to-transparent flex flex-col justify-end p-8 md:p-12">
        <div className="max-w-2xl">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {movie.title}
          </h1>
          <p className="text-white/90 text-base md:text-lg mb-6 line-clamp-3">
            {movie.description}
          </p>
          <div className="flex gap-4">
            <Link to={`/movie/${movie.id}`}>
              <Button size="lg" className="gap-2">
                <Play className="w-5 h-5 fill-current" />
                Play Now
              </Button>
            </Link>
            <Link to={`/movie/${movie.id}`}>
              <Button size="lg" variant="outline" className="gap-2">
                <Info className="w-5 h-5" />
                More Info
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
